import WelcomeWizard from "@Components/wizards/components/welcome-wizard";
import { AppContext } from "@Context/common/general/context";
import WizardConfigs from "@Enums/WizardConfigs";
import { useCallback, useContext, useEffect, useState } from "react";
import { VR_WIZARD_READ_STORAGE_KEY } from "../notification-service.constants";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useNotificationCandidate } from "../use-notification-candidate";

const id = "WELCOME_WIZARD";

const WelcomeWizardNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const [isVRWizardRead, setIsVRWizardRead] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setIsVRWizardRead(localStorage.getItem(VR_WIZARD_READ_STORAGE_KEY) === "TRUE");
  }, []);

  const handleComplete = useCallback(() => {
    localStorage.setItem(VR_WIZARD_READ_STORAGE_KEY, "TRUE");
    setIsVRWizardRead(true);
  }, []);

  const isActive = isVRWizardRead === false && state.device.isVR && !state.user.authenticated;

  const render = useCallback(() => (
    <WelcomeWizard
      config={WizardConfigs.WELCOME_WIZARD_VR}
      onComplete={handleComplete}
    />
  ), [handleComplete]);

  useNotificationCandidate({
    id,
    priority,
    isActive,
    render,
  });

  return null;
};

export const welcomeWizardNotification = defineNotificationModule({
  id,
  Resolver: WelcomeWizardNotificationResolver,
});
